import React, { useState, useEffect, useRef } from "react"
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { useParams } from "react-router-dom";
import BotaoVoltar from "./common/botaoVoltar";
import Collapse from '@mui/material/Collapse';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';
import { URL_API } from '../config/urls'
import fetchWithToken from '../config/UseFetchWithToken';

export default function EditarPrefeitura() {

	const [dados, setDados] = useState({});
	const [dadosAf, setDadosAf] = useState([]);
	let { id } = useParams(0);
	const txtCodigo = useRef(null);
	const txtNome = useRef(null);
	const txtResponsavel = useRef(null);
	const txtEmail = useRef(null);
	const txtAf = useRef(null);
	const [mostraMensagem, setMostrarMensagem] = useState(false);
	const [mensagem, setMensagem] = useState("");

	useEffect(() => {

		let token_keycloack = sessionStorage.getItem('token_keycloack');
		const requestAuthorization = {
			headers: { "Authorization": `Bearer ${token_keycloack}` }
		}

		fetchWithToken(`${URL_API}/api/v1/af/obterAf`, requestAuthorization)
			.then(res => res.json())
			.then(res => {
				if (res === "") {
					this.resultado = "Erro na leitura dos dados de AF"
				}
				else {
					setDadosAf(res)
					if (id > 0) {
						fetchWithToken(`${URL_API}/api/v1/prefeitura/${id}`, requestAuthorization)
							.then(res2 => res2.json())
							.then(res2 => {
								if (res2 === "") {
									this.resultado = "Erro na leitura dos dados"
								}
								else {
									setDados(res2[0])
								}
							})
							.catch(_err => {
								alert("Erro interno na aplicação - " + _err)
								console.error("Erro interno na aplicação - " + _err)
							});
					}
					else {
						setDados({ "codigo": "", "nome": "", "responsavel": "", "email": "", "af": "" })
					}
				}
			})
			.catch(_err => {
				alert("Erro interno na aplicação - " + _err)
				console.error("Erro interno na aplicação - " + _err)
			});
	}, [id])

	function controlarItem(e) {
		setDados(_dados => ({ ...dados, [e.target.name]: e.target.value }))
		return null
	}

	function controlarAf(e) {
		setDados(_dados => ({ ...dados, af: e.target.value }))
		return null
	}

	function fecharMensagem() {
		setMostrarMensagem(false)
		return null
	}

	function salvar(_e) {
		if (id === "0" && dados.codigo !== "") {

			let token_keycloack = sessionStorage.getItem('token_keycloack');
			const requestAuthorization = {
				headers: { "Authorization": `Bearer ${token_keycloack}` }
			}

			fetchWithToken(`${URL_API}/api/v1/prefeitura/obterPorCodigo/${dados.codigo}`, requestAuthorization)
				.then(res => res.text())
				.then(_res => {
					if (_res !== "") {
						alert("Já existe uma prefeitura com esse código!")
						txtCodigo.current.focus()
						return false
					}
				})
				.catch(_err => {
					console.error("Ocorreu um erro - " + _err)
				});
		}
		if (!dados.codigo.trim().length) {
			alert("O campo código é obrigatório!")
			txtCodigo.current.focus()
			return false
		}
		if (!dados.nome.trim().length) {
			alert("O campo nome é obrigatório!")
			txtNome.current.focus()
			return false
		}
		if (!dados.responsavel.trim().length) {
			alert("O campo responsável é obrigatório!")
			txtResponsavel.current.focus()
			return false
		}
		if (!dados.email.trim().length) {
			alert("O campo email é obrigatório!")
			txtEmail.current.focus()
			return false
		}
		if (!dados.email.match(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/)) {
			alert("Email inválido!")
			txtEmail.current.focus()
			return false
		}
		if (!dados.af.trim().length) {
			alert("Selecione uma AF relacionada a prefeitura!")
			txtAf.current.focus()
			return false
		}
		let metodo = 'POST'
		let url = `${URL_API}/api/v1/prefeitura/`
		let token_keycloack = sessionStorage.getItem('token_keycloack');
		if (id > 0) {
			url = url + id
			metodo = 'PUT'
		}
		else{
			url = url + "inserirPrefeitura"
		}
		const opcoes = {
			method: metodo,
			headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${token_keycloack}` },
			body: JSON.stringify(dados)
		};
		fetch(url, opcoes)
			.then(res => res.text())
			.then(_res => {
				const retorno = JSON.parse(_res);
				if(retorno.status === 500){
					setMensagem("Erro interno na aplicação - "+retorno.trace);
				}else{
					if (id === "0") {
						setMensagem("O registro foi incluído!")
					}
					else {
						setMensagem("O registro foi alterado!")
					}
				}
				setMostrarMensagem(true)
				window.scrollTo(0, 0)
			})
			.catch(_err => {
				alert(_err)
				setMensagem("Erro interno na aplicação.")
				console.error("Erro interno na aplicação - " + _err)
			});
			setMostrarMensagem(true)
		return null
	}

	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-12">
					<Collapse in={mostraMensagem}>
						<Alert action={<IconButton aria-label="close" color="inherit" size="small" onClick={ () =>  fecharMensagem() }><CloseIcon fontSize="inherit" /></IconButton>} sx={{ mb: 2 }}>{mensagem}</Alert>
					</Collapse>
					<header className="main">
						<h2>DISTVAF - Cadastro de Prefeitura</h2>
					</header>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<BotaoVoltar />
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<form>
						<label className="margem-antes">Código</label>
						<input type="text" value={dados.codigo || ''} name="codigo" ref={txtCodigo} onChange={controlarItem} maxLength="3" />
						<label className="margem-antes">Nome</label>
						<input type="text" value={dados.nome || ''} name="nome" ref={txtNome} onChange={controlarItem} maxLength="40" />
						<label className="margem-antes">Responsável</label>
						<input type="text" value={dados.responsavel || ''} name="responsavel" ref={txtResponsavel} onChange={controlarItem} maxLength="40" />
						<label className="margem-antes">Email</label>
						<input type="text" value={dados.email || ''} name="email" ref={txtEmail} onChange={controlarItem} maxLength="100" />
						<label className="margem-antes">Telefone</label>
						<input type="text" value={dados.telefone || ''} name="telefone" onChange={controlarItem} maxLength="20" />
						<label className="margem-antes">CPF/CNPJ</label>
						<input type="text" value={dados.identificacao || ''} name="identificacao" onChange={controlarItem} maxLength="14" />
						<label className="margem-antes">AF</label>
						<select value={dados.af} name="codigoAf" onChange={controlarAf} ref={txtAf} >
							{dadosAf.map((reg) => {
								return (
									<option key={"a" + reg.codigo} value={reg.codigo}>{reg.nome}</option>
								)
							})}
						</select>
						<label className="margem-antes">Observação</label>
						<textarea value={dados.obs || ''} name="obs" onChange={controlarItem} rows="10"/> 
						<label className="margem-antes"></label>
						<Button variant="contained" color="primary" onClick={ () => salvar()}>Salvar</Button>
					</form>
				</div>
			</div>
		</div >
	)

}